import { render, staticRenderFns } from "./CompensationStepCardView.vue?vue&type=template&id=0504cb68&scoped=true&"
import script from "./CompensationStepCardView.vue?vue&type=script&lang=js&"
export * from "./CompensationStepCardView.vue?vue&type=script&lang=js&"
import style0 from "./CompensationStepCardView.vue?vue&type=style&index=0&id=0504cb68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0504cb68",
  null
  
)

export default component.exports